import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppConfig} from '../../app.config';

@Injectable()
export class ModulesService {
  constructor (private http: HttpClient , private api: AppConfig) {
  }

  addModule (data) {
    return this.http.post(this.api.baseUrl + '/modules/addModule' , data , this.api.jsonTokenHeaders);
  }

  getModules () {
    return this.http.get(this.api.baseUrl + '/modules/getModules' , this.api.jsonTokenHeaders);
  }

  getModuleById (id) {
    return this.http.get(this.api.baseUrl + '/modules/getModuleById?id=' + id , this.api.jsonTokenHeaders);
  }

  getPages() {
    return this.http.get(this.api.baseUrl + '/page/getPages' , this.api.jsonTokenHeaders);
  }

  addMatrixModule(data){
    return this.http.post(this.api.baseUrl + '/matrixModule/addMatrixModule' , data , this.api.jsonTokenHeaders);
  }

  getMatrixModules(page = 1, perPage = 50, search = '') {
    return this.http.get(this.api.baseUrl + '/matrixModule/getMatrixModules?page=' + page +
      '&perPage=' + perPage + '&search=' + search, this.api.jsonTokenHeaders);
  }

  getByOrganizationId (id) {
    return this.http.get(this.api.baseUrl + '/matrixModule/getByOrganizationId?id=' + id , this.api.jsonTokenHeaders);
  }

  getAllowedByUser () {
    return this.http.get(this.api.baseUrl + '/matrixModule/getAllowedByUser' , this.api.jsonTokenHeaders);
  }

  enableModuleToAllOrg(id) {
    return this.http.get(this.api.baseUrl + '/matrixModule/enableModuleToAllOrg?id=' + id , this.api.jsonTokenHeaders);
  }
}
